import { checkPasswordValidity, setPasswordEmpty } from "@/service/user.js";
import UpdatePassword from "@/components/Modal/UpdatePassword";
import passwordModal from "@/views/MGT/passwordModal/passwordModal.vue";
import { mapActions } from "vuex";
import { getAccountType, getPasswordType } from "@/libs/auth";
export default {
  name: "ValidPassword",
  components: {
    UpdatePassword,
    passwordModal
  },
  data() {
    return {
      visible: false,
      loading: false
    };
  },
  mounted() {
    this.valodPassword();
    this.initPassword();
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    async valodPassword() {
      if (localStorage.getItem("PasswordExpired")) {
        return;
      }
      let params = {};
      let {
        data: {
          result,
          retVal
        }
      } = await checkPasswordValidity(params);
      if (result === 0) {
        if (!retVal) {
          // 密码登录才触发
          let accountType = getAccountType();
          let passwordType = getPasswordType();
          if ((accountType === "MOBILE" || passwordType === "EMAIL") && passwordType === "password") {
            this.visible = true;
          }
          localStorage.setItem("PasswordExpired", "true");
        }
      }
    },
    async initPassword() {
      if (localStorage.getItem("shouldInitPassword")) {
        return;
      }
      let {
        retVal: {
          shouldInitPassword
        }
      } = await this.getUserInfo();
      if (shouldInitPassword === "T") {
        localStorage.setItem("shouldInitPassword", "T");
        this.$refs.passwordModalRef.open();
      }
    },
    /*
     *  删除密码
     */
    async onClear() {
      let params = {};
      this.loading = true;
      let res = await setPasswordEmpty(params);
      this.loading = false;
      if (res && res.data && res.data.result === 0) {
        this.$Message.success($t("t6vhma6", "删除密码成功"));
        this.visible = false;
      }
    },
    /*
     *  立即修改密码
     */
    onUpdate() {
      this.$refs["updatePassword"].init();
    },
    /*
     * 密码更新成功
     */
    onSuccessUpdate() {
      this.visible = false;
      this.$Modal.remove();
    }
  }
};